// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProjectToolbar__toolbarRibbon___GPME4 {
    height: var(--space-3xl);
    padding-left: 0.8rem;
    background: var(--color-bg-secondary);
    border-bottom: 0.1rem solid var(--color-bg-border);
}

.ProjectToolbar__toolbarRibbonScroll___IyhWr {
    overflow-x: auto;
    display: flex;

    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
    padding-right: 0.8rem;

    white-space: nowrap;
}

.ProjectToolbar__toolbarRibbonButtonColor___x72BT {
    background-color: var(--color-bg-ghost);
}

.ProjectToolbar__interpretationList___QiD6K {
    display: flex;
}

.ProjectToolbar__modelingList___dXeq0 {
    display: flex;
}

.ProjectToolbar__btnMargin___MHWfO {
    margin-right: 1.2rem;
}

.ProjectToolbar__container___hk5vD {
    display: flex;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/Header/ProjectToolbar/ProjectToolbar.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,qCAAqC;IACrC,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,aAAa;;IAEb,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;;IAErB,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".toolbarRibbon {\n    height: var(--space-3xl);\n    padding-left: 0.8rem;\n    background: var(--color-bg-secondary);\n    border-bottom: 0.1rem solid var(--color-bg-border);\n}\n\n.toolbarRibbonScroll {\n    overflow-x: auto;\n    display: flex;\n\n    margin-top: 0.8rem;\n    margin-bottom: 0.8rem;\n    padding-right: 0.8rem;\n\n    white-space: nowrap;\n}\n\n.toolbarRibbonButtonColor {\n    background-color: var(--color-bg-ghost);\n}\n\n.interpretationList {\n    display: flex;\n}\n\n.modelingList {\n    display: flex;\n}\n\n.btnMargin {\n    margin-right: 1.2rem;\n}\n\n.container {\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbarRibbon": `ProjectToolbar__toolbarRibbon___GPME4`,
	"toolbarRibbonScroll": `ProjectToolbar__toolbarRibbonScroll___IyhWr`,
	"toolbarRibbonButtonColor": `ProjectToolbar__toolbarRibbonButtonColor___x72BT`,
	"interpretationList": `ProjectToolbar__interpretationList___QiD6K`,
	"modelingList": `ProjectToolbar__modelingList___dXeq0`,
	"btnMargin": `ProjectToolbar__btnMargin___MHWfO`,
	"container": `ProjectToolbar__container___hk5vD`
};
export default ___CSS_LOADER_EXPORT___;
